import LoadingButton from "@mui/lab/LoadingButton";
import {useState} from "react";
import DownloadIcon from '@mui/icons-material/Download';
import axios from "axios";
import {ApiUrl} from "../../auth/authMethods";

export default function DownloadLogBookFile({file, baseUrl}) {

    const [loading, setLoading] = useState(false)

    const url = baseUrl + 'download/' + file.id

    const handleClick = () => {
        setLoading(true)

        const axiosConfig = {
            method: 'get',
            url: url,
            responseType: 'blob'
        };

        // Realiza a requisição Axios
        axios(axiosConfig)
            .then(response => {
                // Cria um objeto URL para o blob
                const blobUrl = URL.createObjectURL(response.data);

                // Cria um link para download
                const link = document.createElement('a');
                link.href = blobUrl;
                link.download = file.filename;

                // Adiciona o link ao corpo do documento
                document.body.appendChild(link);

                // Simula um clique no link para iniciar o download
                link.click();

                // Remove o link do corpo do documento após o download
                document.body.removeChild(link);
            })
            .catch(error => console.error('Erro ao baixar arquivo:', error))
            .finally(() => {
                setLoading(false)
            })
    }

    return <LoadingButton
        onClick={handleClick}
        loading={loading}
        loadingPosition="start"
        startIcon={<DownloadIcon />}
        variant="outlined"
        style={{
            maxWidth: '200px', // Ajuste conforme necessário
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            margin: '4px'
        }}
        title={file.filename} // Exibe o nome completo ao passar o mouse
    >
        <span
            style={{
                display: 'inline-block',
                maxWidth: '150px', // Ajuste para caber dentro do botão
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis'
            }}
        >
            {file.filename}
        </span>
    </LoadingButton>
}